export function getPortalSession() {
  try {
    return JSON.parse(localStorage.getItem("client") || "{}");
  } catch (_) {
    return {};
  }
}

export function isPortalOwner(session = getPortalSession()) {
  return session?.portal_role !== "tenant_user";
}

export function canDeleteInPortal(session = getPortalSession()) {
  return isPortalOwner(session);
}

export const canPortalDelete = canDeleteInPortal;
